<template>
    <div id="futurocoin_table_component"
         class="futurocoin-table-component">
        <h3 style="margin-top: 25px;">Transfer history</h3>
        <b-row style="margin-top: 24px;">
            <b-col lg="4">
                <type></type>
            </b-col>
        </b-row>
        <div class="futurocoin-table-outer table-responsive">
            <div class="data-loader" v-if="loader"></div>
            <div class="table-outer">
                <table class="table-style1">
                    <thead>
                    <tr>
                        <th>
                            <div class="calendar-icon">
                                <p>Date</p>
                                <i class="mdi mdi-calendar"></i>
                                <datepicker placeholder="range"
                                            :options="{ mode: 'range', maxDate: 'today' }"
                                            v-model="date"></datepicker>
                            </div>
                            <div class="sort-icon"
                                 @click="changeSort('date')">
                                <i class="mdi mdi-chevron-up"></i>
                                <i class="mdi mdi-chevron-down"></i>
                            </div>
                        </th>
                        <th @click="changeSort('amount')"><p>Amount</p>
                            <div class="sort-icon">
                                <i class="mdi mdi-chevron-up"></i>
                                <i class="mdi mdi-chevron-down"></i>
                        </div></th>
                        <th @click="changeSort('type')"><p>Type</p>
                            <div class="sort-icon">
                                <i class="mdi mdi-chevron-up"></i>
                                <i class="mdi mdi-chevron-down"></i>
                            </div></th>
                        <th>
                            <p>Status</p>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(transfer, index) in transferHistory"
                        :key="index">
                        <td>
                            <p>{{ datetime.utcToLocal(transfer.date) }}</p>
                        </td>
                        <td>
                            <p>{{  money.format(transfer.amount.amount, 'fto') }} FTO</p>
                        </td>
                        <td>
                            <p>{{ getTypeName(transfer.type_name) }}</p>
                        </td>
                        <td>
                            <p>{{ transfer.status.status }}</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p v-if="transferHistory.length == 0" style="margin-top: 25px;">No results.</p>
            </div>
        </div>
        <pagination-component :current-page="currentPage"
                              :items="items"
                              :loader="loader"
                              :number-of-pages="numberOfPages"
                              :set-items="setItems"
                              :set-page="setPage"></pagination-component>
    </div>
</template>

<script>
    import Type from './Type.vue'
    export default {
        dependencies: ['datetime', 'money'],
        components: { Type },
        data () {
            return {
                date: '',
                items: 25
            }
        },
        computed: {
            transferHistory () {
                return this.$store.getters.transferHistory;
            },
            currentPage () {
                return this.$store.getters.transferHistorySettings.currentPage;
            },
            maxPerPage () {
                return this.$store.getters.transferHistorySettings.maxPerPage;
            },
            numberOfPages () {
                return this.$store.getters.transferHistorySettings.numberOfPages;
            },
            loader () {
                return this.$store.getters.transferHistoryLoader;
            }
        },
        methods: {
            /**
             * Change sort
             */
            changeSort: function (field) {
                this.$store.dispatch('transferHistorySetSort', field).then(() => {
                    this.getData();
                });
            },

            /**
             * Set default settings
             */
            clearSettings () {
                this.$store.dispatch('transferHistorySettingsClear').then(() => {
                    this.getData();
                    this.items = 25;
                });
            },

            /**
             * Get data with transactions
             */
            getData () {
                this.loader = true;

                let settings = this.$store.getters.transferHistorySettings;

                this.$store.dispatch('loadTransferHistory', {
                    params: settings
                }).then(() => {
                    this.loader = false;
                });
            },

            /**
             * Set number of items per page
             */
            setItems (items) {
                this.items = items;
                this.$store.dispatch('transferHistorySetItems', items).then(() => {
                    this.setPage(1);
                });
            },

            /**
             * Set current page
             * @param page
             */
            setPage (page) {
                this.$store.dispatch('transferHistorySetPage', page).then(() => {
                    this.getData();
                    window.scrollTo(0,0);
                });
            },

            /**
             * Get type name by key
             */
            getTypeName (type) {
                let types = {
                    royal_bonus: 'Royal bonus',
                    mining: 'Mining'
                };

                return types[type];
            }
        },
        watch: {
            /**
             * Get data with transfers if date in calendar was changed
             */
            date () {
                this.$store.dispatch('transferHistorySetDate', this.date).then(() => {
                    this.getData();
                });
            }
        },
        beforeMount () {
            let settings = this.$store.getters.transferHistorySettings;

            this.$store.dispatch('loadTransferHistory', {
                params: settings
            }).then(() => {
                this.items = settings.maxPerPage;
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../assets/scss/_colors.scss';

    .futurocoin-table-component{
        position: relative;
    }

    .futurocoin-table-outer{
        margin-top: 11px;
        thead,
        tbody{
            tr{
                th,
                td{
                    &:first-child{
                        width: 14%;
                    }
                }
            }
        }
    }

    th{
        white-space: nowrap;

        p{
            display: inline-block;
            max-width: 85%;
            white-space: normal;
            vertical-align: middle;
            cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/futurocoin-history/FuturocoinHistoryTable.vue